import React from "react";
import { Button, Modal } from "antd";
import { CustomIcons } from "@/assets/index";
import { modelTitle } from "@/styles/ModalStyles";

interface ViewResponderAdminModalProps {
  isOpen: boolean;
  onClose: () => void;
  adminData: {
    createdAt: string;
    firstName: string;
    lastName: string;
    responderCompany: string;
  } | null;
}

const ViewResponderAdminModal: React.FC<ViewResponderAdminModalProps> = ({
  isOpen,
  onClose,
  adminData,
}) => {
  const formatDate = (dateString: string) => {
    if (!dateString) return "-";
    return new Date(dateString).toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  };

  const handleClose = () => {
    onClose();
  };

  return (
    <Modal
      centered
      open={isOpen}
      onCancel={handleClose}
      width={500}
      closeIcon={
        <CustomIcons.CloseIcon
          width={30}
          height={30}
          viewBox={null}
          svgColor="#1C274C"
        />
      }
      footer={null}
    >
      <div className="flex w-full py-3 justify-center" style={modelTitle}>
        Responder Admin Details
      </div>

      {adminData && (
        <div className="mb-6 space-y-4">
          <div className="bg-gray-50 p-4 rounded-lg space-y-3">
            <div className="flex justify-between items-center">
              <span className="font-medium text-gray-700">Date Added:</span>
              <span className="text-gray-900">
                {formatDate(adminData.createdAt)}
              </span>
            </div>

            <div className="flex justify-between items-center">
              <span className="font-medium text-gray-700">First Name:</span>
              <span className="text-gray-900">{adminData.firstName}</span>
            </div>

            <div className="flex justify-between items-center">
              <span className="font-medium text-gray-700">Last Name:</span>
              <span className="text-gray-900">{adminData.lastName}</span>
            </div>

            <div className="flex justify-between items-center">
              <span className="font-medium text-gray-700">Company:</span>
              <span className="text-gray-900">
                {adminData.responderCompany}
              </span>
            </div>
          </div>
        </div>
      )}

      {/* Footer Button */}
      <div className="flex w-full justify-center pt-4">
        <Button
          type="primary"
          size="large"
          className="px-8 py-2 h-12 rounded-full bg-saferCity-primary hover:bg-saferCity-primary/80 border-saferCity-primary hover:border-saferCity-primary/80"
          onClick={handleClose}
        >
          Close
        </Button>
      </div>
    </Modal>
  );
};

export default ViewResponderAdminModal;
